import { errorMessage, getCertificate, isOk } from '../../helpers/trainingApi'
import { downloadCertificatePdf } from '../pdf/certificateDownload'

// Fetches an e-learning certificate and downloads it as a PDF (the same
// document the learner gets). Resolves with an error message, or null when
// the download started.
export const downloadCertificate = async (certificateId) => {
  const res = await getCertificate(certificateId)
  if (!isOk(res)) return errorMessage(res, 'Unable to load this certificate.')
  try {
    await downloadCertificatePdf(res.data)
    return null
  } catch (e) {
    console.error(e)
    return 'Unable to generate the certificate PDF.'
  }
}
